import { getParameterByName } from './utils'

export const isTabConnectMode = () => {
  const linkCode = getParameterByName('linkCode')
  const tab = getParameterByName('tab')

  return linkCode && tab !== null
}
